import { render, staticRenderFns } from "./OrdenView.vue?vue&type=template&id=2d7073b0&scoped=true&"
import script from "./OrdenView.vue?vue&type=script&lang=js&"
export * from "./OrdenView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7073b0",
  null
  
)

export default component.exports